"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _styles = require("@mui/material/styles");
var _content = _interopRequireDefault(require("./components/content"));
var _input_mol = _interopRequireDefault(require("./components/input_mol"));
var _input_file = _interopRequireDefault(require("./components/input_file"));
var _input_form = _interopRequireDefault(require("./components/input_form"));
var _input_pred_json = _interopRequireDefault(require("./components/input_pred_json"));
var _loading = _interopRequireDefault(require("./components/loading"));
var _notice = _interopRequireDefault(require("./components/notice"));
/* eslint-disable react/jsx-indent */

const theme = (0, _styles.createTheme)();
const styles = () => ({
  root: {
    flexGrow: 1
  }
});
const FullVersion = _ref => {
  let {
    classes,
    editorOnly
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: classes.root,
    spacing: 10
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-space",
    item: true,
    xs: 1
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-mol",
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_input_mol.default, null)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-file",
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_input_file.default, {
    editorOnly: editorOnly
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-pred-json",
    item: true,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_input_pred_json.default, null)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-form-input",
    item: true,
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_input_form.default, null)));
};
FullVersion.propTypes = {
  classes: _propTypes.default.object.isRequired,
  editorOnly: _propTypes.default.bool.isRequired
};
const editortext = classes => /*#__PURE__*/_react.default.createElement("span", {
  className: (0, _classnames.default)(classes.etSpan, 'txt-sv-etext')
}, "(1) Upload a spectrum file to the dashed box on the right. Valid formats: *.dx, *.jdx, *.JCAMP, *.fid, *.zip (Bruker), *.RAW (ThermoFisher), *.mz(X)ML. A 2D spectrum is NOT available. One spectrum only, not several in parallel. (2) Click the submit button");
const EditorVersion = _ref2 => {
  let {
    classes,
    editorOnly
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: classes.root,
    spacing: 24
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-space",
    item: true,
    xs: 1
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-mol",
    item: true,
    xs: 7
  }, editortext(classes)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-file",
    item: true,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_input_file.default, {
    editorOnly: editorOnly
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-form-input",
    item: true,
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_input_form.default, null)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    key: "grid-drop-space",
    item: true,
    xs: 1
  }));
};
EditorVersion.propTypes = {
  classes: _propTypes.default.object.isRequired,
  editorOnly: _propTypes.default.bool.isRequired
};
const Frame = _ref3 => {
  let {
    classes,
    editorOnly
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement("div", null, editorOnly ? /*#__PURE__*/_react.default.createElement(EditorVersion, {
    classes: classes,
    editorOnly: editorOnly
  }) : /*#__PURE__*/_react.default.createElement(FullVersion, {
    classes: classes,
    editorOnly: editorOnly
  }), /*#__PURE__*/_react.default.createElement(_content.default, {
    editorOnly: editorOnly
  }), /*#__PURE__*/_react.default.createElement(_notice.default, null), /*#__PURE__*/_react.default.createElement(_loading.default, null)));
};
Frame.propTypes = {
  classes: _propTypes.default.object.isRequired,
  editorOnly: _propTypes.default.bool.isRequired
};
var _default = exports.default = (0, _withStyles.default)(styles)(Frame);